import React, { useRef, useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { BrCalendar } from './BrCalendar';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { InputNumber } from 'primereact/inputnumber';

export const TabelaBoletimItens = ({ isEditing, boletimItens, setBoletimItens }) => {
    const toast = useRef(null);
    // eslint-disable-next-line  no-unused-vars
    const [boletinsItens, setBoletinsItens] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null);
    const { id } = useParams();
    const history = useHistory();

    /* eslint-disable array-callback-return */

    useEffect(() => {
        const fetchBoletimItens = async () => {
            try {
                await getBoletimItens();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchBoletimItens();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const getBoletimItens = async () => {
        setBoletinsItens([])

        try {

            if (isEditing) {
                const response = await api.get(`boletim/${id}`);
                console.log("Itens do boletim:", response.data.itens);

                response.data.itens.map(boletimItem => {
                    setBoletinsItens(boletimItens => [...boletimItens, boletimItem])
                })
            }

        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter boletim itens', detail: error.toString() });
        }
    }

const handleGoToCaderno = async (itemId) => {
    try {
        console.log("Verificando caderno de campo para o item:", itemId);
        const response = await api.get(`/caderno/boletimItem/${itemId}`);
        console.log("Resposta da API:", response.data);

        if (response.data) {
            console.log("Caderno de campo encontrado. Redirecionando para edição.");
            history.push(`/caderno/edit/${itemId}`);
        } else {
            console.log("Caderno de campo não encontrado. Redirecionando para criação.");
            history.push(`/caderno/${itemId}`);
        }
    } catch (error) {
        console.error("Erro ao verificar caderno de campo:", error);
        console.log("Erro ao verificar caderno. Redirecionando para criação.");
        history.push(`/caderno/${itemId}`);
    }
};


    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">

                <div className="actions">
                    <Button
                        type="button"
                        icon="pi pi-book"
                        className="p-button-rounded p-mr-2"
                        onClick={() => handleGoToCaderno(rowData.itensId)}
                    />
                </div>

                <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-rounded p-mr-2 p-button-danger"
                    loading={isDeleting}
                    onClick={() => handleDeleteClick(rowData)}
                />


            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.produtoId}</span>
                </p>
            </React.Fragment>
        );
    }



    const produtoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Produto</span>
                    <span className="table-data">{rowData.produtoNome === undefined ? rowData.nome : rowData.produtoNome}</span>
                </p>
            </React.Fragment>
        );
    }


    const areaProducaoBodyTemplate = (rowData) => {
        return new Intl.NumberFormat('pt-BR', { currency: 'BRL' }).format(rowData.areaProducao);
    }


    const producaoEstimadaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Produção Estimada Kg</span>
                    <span className="table-data">{rowData.producaoEstimada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </p>
            </React.Fragment>
        );
    }

    const producaoEmbaladaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Produção Embalada</span>
                    <span className="table-data">{rowData.producaoEmbalada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </p>
            </React.Fragment>
        );
    }


    const embalagemBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Embalagem</span>
                    <span className="table-data">{rowData.produtoEmbalagem}</span>
                </p>
            </React.Fragment>
        );
    }


    const inicioColheitaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Inicio Colheita</span>
                    <span className="table-data">{new Date(rowData.inicioColheita).toLocaleDateString()}</span>
                </p>
            </React.Fragment>
        );
    }

    const fimColheitaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Fim Colheita</span>
                    <span className="table-data">{new Date(rowData.fimColheita).toLocaleDateString()}</span>
                </p>
            </React.Fragment>
        );
    }

    const handleDeleteClick = (data) => {

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.produtoNome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => {
                setIsDeleting(true);

                try {

                    setBoletimItens(boletimItens.filter(item => item !== data));
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Boletim ${data.produtoNome} removido(a) com sucesso` });

                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o boletim', detail: error.response.data });
                }

                setIsDeleting(false);
            }

        });
    }

    useEffect(() => {

    }, [boletimItens]);

    const onRowEditComplete1 = (e) => {
        let boletimItens2 = [...boletimItens];
        let { newData, index } = e;

        boletimItens2[index] = newData;

        setBoletimItens(boletimItens2);
    }


    const priceEditorAreaProducao = (options) => {

        return <InputNumber value={options.rowData.areaProducao} onValueChange={((e) => { handleEdit(options.rowData, 'areaProducao', e.value) })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />


    }

    const handleEdit = (data, campo, value) => {

        data[campo] = value;

    }


    const priceEditorProducaoEstimada = (options) => {


        return <InputNumber value={options.rowData.producaoEstimada} onValueChange={((e) => { handleEdit(options.rowData, 'producaoEstimada', e.value) })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />

    }

    const priceEditorProducaoEmbalada = (options) => {


        return <InputNumber value={options.rowData.producaoEmbalada} onValueChange={((e) => { handleEdit(options.rowData, 'producaoEmbalada', e.value) })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />

    }

    const priceEditorInicioColheita = (options) => {

        return <BrCalendar
            id="inicioColheita"
            name="inicioColheita"
            disabledDays={[]}
            value={new Date(options.rowData.inicioColheita)}
            onChange={((e) => { handleEdit(options.rowData, 'inicioColheita', e.value) })}

            readonly={true}

            yearRange={`2010:${new Date().getFullYear() + 3}`}
        />




    }

    const priceEditorFimColheita = (options) => {

        return <BrCalendar
            id="fimColheita"
            name="fimColheita"
            disabledDays={[]}
            value={new Date(options.rowData.fimColheita)}
            onChange={((e) => { handleEdit(options.rowData, 'fimColheita', e.value) })}

            readonly={true}

            yearRange={`2010:${new Date().getFullYear() + 3}`}
        />




    }


    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable

                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={boletimItens}



                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma boletim encontrado"
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} boletim Itens"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort

                    >

                        <Column style={{ width: '12%' }}
                            field="id"
                            header="Código"
                            sortable
                            body={codigoBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pelo Código"

                        />



                        <Column
                            field="produtoNome"
                            header="Nome do Produto"
                            sortable
                            body={produtoBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pelo Produto"

                        />

                        <Column
                            field="areaProducao"
                            header="Área Produção (ha)"
                            body={areaProducaoBodyTemplate}
                            editor={(options) => priceEditorAreaProducao(options)}
                            style={{ width: '10%' }}

                        />


                        <Column
                            field="producaoEstimada"
                            header="Produção Estimada"
                            sortable
                            body={producaoEstimadaBodyTemplate}
                            editor={(options) => priceEditorProducaoEstimada(options)}
                            style={{ width: '10%' }}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pela Produção Estimada Kg"

                        />


                        <Column
                            field="producaoEmbalada"
                            header="Produção Embalada"
                            sortable
                            body={producaoEmbaladaBodyTemplate}
                            editor={(options) => priceEditorProducaoEmbalada(options)}
                            style={{ width: '10%' }}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pela Produção Embalada"

                        />


                        <Column
                            field="produtoEmbalagem"
                            header="Embalagem"
                            sortable
                            body={embalagemBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pela Embalagem"

                        />


                        <Column
                            field="inicioColheita"
                            header="Inicio Colheita"
                            sortable
                            body={inicioColheitaBodyTemplate}
                            editor={(options) => priceEditorInicioColheita(options)}
                            style={{ width: '12%' }}
                        // filter
                        // filterMatchMode="custom"
                        // filterFunction={filterDate}
                        // filterElement={dateFilter}

                        />


                        <Column
                            field="fimColheita"
                            header="Fim Colheita"
                            sortable
                            body={fimColheitaBodyTemplate}
                            editor={(options) => priceEditorFimColheita(options)}
                            style={{ width: '12%' }}
                        // filter
                        // filterMatchMode="custom"
                        // filterFunction={filterDate}
                        // filterElement={dateFilter}

                        />


                        <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}>
                        </Column>




                        <Column
                            header="Ações"
                            body={actionBodyTemplate}

                        />

                    </DataTable>

                </div>
            </div>
        </div>

    );
}
